import script from "./MCP_CR_001.vue?vue&type=script&setup=true&lang=js"
export * from "./MCP_CR_001.vue?vue&type=script&setup=true&lang=js"

import "./MCP_CR_001.vue?vue&type=style&index=0&id=25242ccf&lang=css"

const __exports__ = script;

export default __exports__